<template>

    <el-dialog
        v-model="editUserAvatarForm"
        title="修改头像"
        width="500"
        destroy-on-close
        center>
        <span>
        <div class="mb-3 row">
            <label for="avatarFile" class="col-sm-2 col-form-label">图片</label>
            <div class="col-sm-9">
            <input
                type="file"
                class="form-control"
                id="avatarFile"
                />
            </div>
            <div class="col-sm-1">
            <span style="color: red">*</span>
            </div>
        </div>
        </span>
        <template #footer>
        <div class="dialog-footer">
            <el-button @click="editUserAvatarForm = false">取消</el-button>
            <el-button type="submit" @click="editUserAvatar();"> 提交 </el-button>
        </div>
        </template>
    </el-dialog>


    <el-dialog
        v-model="editPasswordForm"
        title="修改密码"
        width="500"
        destroy-on-close
        center>
        <span>
        <div class="mb-3 row">
            <label for="oldPassword" class="col-sm-3 col-form-label">旧密码:</label>
            <div class="col-sm-8">
            <input
                type="password"
                class="form-control"
                id="oldPassword"
                />
            </div>
            <div class="col-sm-1">
            <span style="color: red">*</span>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="newPassword" class="col-sm-3 col-form-label">新密码:</label>
            <div class="col-sm-8">
                <input
                type="password"
                class="form-control"
                id="newPassword"
                />
            </div>
            <div class="col-sm-1">
            <span style="color: red">*</span>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="rightPassword" class="col-sm-3 col-form-label">确认密码:</label>
            <div class="col-sm-8">
                    <input
                    type="password"
                    class="form-control"
                    id="rightPassword"
                    />
            </div>
            <div class="col-sm-1">
            <span style="color: red">*</span>
            </div>
        </div>
        </span>
        <template #footer>
        <div class="dialog-footer">
            <el-button @click="editPasswordForm = false">取消</el-button>
            <el-button type="submit" @click="editPassword();"> 提交 </el-button>
        </div>
        </template>
    </el-dialog>


    <NavComponents/>
   <div class="container">
    
    <el-row :gutter="20">
        <el-col :span="6" class="border infoBorder">
            <img :src="$store.state.user.avatar" class="userAvatar">
            <hr>
            <el-row :gutter="20" class="elBorder">
                <el-col :span="10"><el-button type="success" class="imgBtn" @click="editUserAvatarForm = true" plain>更换头像</el-button></el-col>
                <el-col :span="10"> <el-button type="warning" class="imgBtn" @click="editPasswordForm = true" plain>修改密码</el-button></el-col>
            </el-row>
        </el-col>

        <el-col :span="15" class="border infoBorder">
            <el-row :gutter="20" class="elBorder">
                <el-col :span="6">
                    <div class="font_1">用户名:</div>
                </el-col>
                <el-col :span="10">
                    <input class="font_1 form-control" type="text" id="userName" :value="$store.state.user.userName" :disabled="userNameFlag">
                </el-col>
                <el-col :span="2">
                    <el-button type="primary" icon="Edit" class="form-control" v-if="userNameFlag" @click="userNameFlag = false" plain />
                    <el-button type="success" icon="Finished" class="form-control" v-if="!userNameFlag" @click="editUserName()" plain />
                </el-col>
            </el-row>

            <el-row :gutter="20" class="elBorder">
                <el-col :span="6">
                    <div class="font_1">姓名:</div>
                </el-col>
                <el-col :span="10">
                    <input class="font_1 form-control" type="text" id="nickName" :value="$store.state.user.nickName" :disabled="nickNameFlag">
                </el-col>
                <el-col :span="2">
                    <el-button type="primary" icon="Edit" class="form-control" v-if="nickNameFlag" @click="nickNameFlag = false" plain />
                    <el-button type="success" icon="Finished" class="form-control" v-if="!nickNameFlag" @click="editNickName()" plain />
                </el-col>
            </el-row>

            <el-row :gutter="20" class="elBorder">
                <el-col :span="6">
                    <div class="font_1">性别:</div>
                </el-col>
                <el-col :span="10">
                    <select
                        class="form-select font_1"
                        id="userGender"
                        name="userGender"
                        v-model="$store.state.user.gender"
                        :disabled="genderFlag"
                        >
                        <option value="0">男</option>
                        <option value="1">女</option>
                        <option value="2">保密</option>
                    </select>
                </el-col>
                <el-col :span="2">
                    <el-button type="primary" icon="Edit" class="form-control" v-if="genderFlag" @click="genderFlag = false" plain />
                    <el-button type="success" icon="Finished" class="form-control" v-if="!genderFlag" @click="editGender()" plain />
                </el-col>
            </el-row>

            <el-row :gutter="20" class="elBorder">
                <el-col :span="6">
                    <div class="font_1">联系方式:</div>
                </el-col>
                <el-col :span="10">
                    <input class="font_1 form-control" type="text" id="phone" :value="$store.state.user.phone" :disabled="phoneFlag">
                </el-col>
                <el-col :span="2">
                    <el-button type="primary" icon="Edit" class="form-control" v-if="phoneFlag" @click="phoneFlag = false" plain />
                    <el-button type="success" icon="Finished" class="form-control" v-if="!phoneFlag" @click="editPhone()" plain />
                </el-col>
            </el-row>

            <el-row :gutter="20" class="elBorder">
                <el-col :span="6">
                    <div class="font_1">邮箱:</div>
                </el-col>
                <el-col :span="10">
                    <input class="font_1 form-control" type="text" id="email" :value="$store.state.user.email" :disabled="emailFlag">
                </el-col>
                <el-col :span="3" v-if="! codeFlag">
                    <input class="form-control" type="text" id="code" placeholder="验证码">
                </el-col>
                <el-col :span="2">
                    <el-button type="primary" icon="Edit" class="form-control" v-if="emailFlag" @click="emailFlag = false" plain />
                    <el-button type="success" icon="Finished" class="form-control" v-if="!emailFlag && codeFlag" @click="editEmail()" plain />
                    <el-button type="success" icon="Finished" class="form-control" v-if="! codeFlag" @click="editEmailOk()" plain />
                </el-col>
            </el-row>




            <el-row :gutter="20" class="elBorder">
                <el-col :span="6">
                    <div class="font_1">个人介绍:</div>
                </el-col>
                <el-col :span="10">
                    <textarea class="font_1 form-control" rows="6" id="introduce" :value="$store.state.user.introduce" :disabled="introduceFlag"></textarea>
                </el-col>
                <el-col :span="2">
                    <el-button type="primary" icon="Edit" class="form-control" v-if="introduceFlag" @click="introduceFlag = false" plain />
                    <el-button type="success" icon="Finished" class="form-control" v-if="!introduceFlag" @click="editIntroduce()" plain />
                </el-col>
            </el-row>
            
        </el-col>
    </el-row>
    
    </div>
</template>

<script setup>
import NavComponents from '@/components/nav/NavComponents.vue';
import { ref } from 'vue';
import $ from 'jquery'
import { ElMessage } from 'element-plus';
import store from '@/store';

const userNameFlag = ref(true);
const nickNameFlag = ref(true);
const genderFlag = ref(true);
const phoneFlag  = ref(true);
const introduceFlag = ref(true);
const emailFlag = ref(true);
const codeFlag = ref(true);
import router from '@/router/index'

const editPasswordForm = ref(false);
const editUserAvatarForm = ref(false);
const token = localStorage.getItem("token");
const userNameReg = /^[a-zA-Z0-9_]{5,12}$/;
const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;


const editUserAvatar = () => {

    // 判断头像
    if ($("#avatarFile")[0].files.length == 0) {
        ElMessage({
            type: "error",
            message: "头像未上传！",
            });
        return false;
    }

    var formData = new FormData();
    formData.append("file", $("#avatarFile")[0].files[0]); // 添加图片
    formData.append("userId", store.state.user.id); // 添加ID
    formData.append("link", store.state.user.avatar); // 之前图片链接

    editUserAvatarForm.value = false;

    $.ajax({
        url: "http://124.222.105.205:5000/api/user/updateUserAvatar",
        type: "post",
        data: formData,
        headers: {
        Authorization: "Bearer " + token,
        },
        processData: false, // 告诉jQuery不要去处理发送的数据
        contentType: false, // 告诉jQuery不要去设置Content-Type请求头
        dataType: "text",
        success: function (resp) {
            let result = JSON.parse(resp);
            if (result.code == "200") {
                ElMessage({
                    type: "success",
                    message: result.msg
                });
                location.reload();
            } else {
                ElMessage({
                    type: "error",
                    message: result.msg
                });
            }
        },
        error: function () {
            ElMessage({
                type: "error",
                message: "更改头像失败！",
            });
        },
    });
}

const editUserName = () => {


    let userName = $("#userName").val();

    if (userName == store.state.user.userName) {
        ElMessage({
            type: "success",
            message: "修改成功!",
        });
        userNameFlag.value = true;
        return false;
    }

    if (! userNameReg.test(userName)) {
        ElMessage({
            type: "error",
            message: "请输入5~12的数字, 字母, 以及 _ 下划线",
        });
        return false;
    }
    

    $.ajax({
        url: "http://124.222.105.205:5000/get/user/hasUesrByUserName",
        type: "post",
        data:{
            userName: userName,
        },
        success(resp) {
            if (resp.code == "200"){
                ElMessage({
                    type: "error",
                    message: "该用户名已存在",
                });
            } else {
                editUserNameOK(userName);
            }
        },
        error() {
            ElMessage({
            type: "error",
            message: "服务器异常!请稍后再试!",
            });
        }
        });
   
}

const editUserNameOK = (userName) => {
    $.ajax({
        url: "http://124.222.105.205:5000/api/user/updateUserName",
        data: {
            userName: userName,
            userId: store.state.user.id,
        },
        type: "post",
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
            ElMessage({
                type: "success",
                message: resp.msg,
            });
            location.reload();
            } else {
            ElMessage({
                type: "error",
                message: resp.msg,
            });
            }
        },
        error() {
            ElMessage({
            type: "error",
            message: "服务器异常!请稍后再试!",
            });
        },
        });
}

const editNickName = () => {


let nickName = $("#nickName").val();

if (nickName == store.state.user.nickName) {
    ElMessage({
        type: "success",
        message: "修改成功!",
    });
    nickNameFlag.value = true;
    return false;
}

if (nickName == null || nickName == "") {
    ElMessage({
        type: "error",
        message: "姓名不能为空",
    });
    return false;
}

$.ajax({
    url: "http://124.222.105.205:5000/api/user/updateNickName",
    data: {
        nickName: nickName,
        userId: store.state.user.id,
    },
    type: "post",
    headers: {
        Authorization: "Bearer " + token,
    },
    success(resp) {
        if (resp.code == "200") {
        ElMessage({
            type: "success",
            message: resp.msg,
        });
        location.reload();
        } else {
        ElMessage({
            type: "error",
            message: resp.msg,
        });
        }
    },
    error() {
        ElMessage({
        type: "error",
        message: "服务器异常!请稍后再试!",
        });
    },
});


}

const editGender = () => {

let userGender = $("#userGender").val();

if (userGender == store.state.user.userGender) {
    ElMessage({
        type: "success",
        message: "修改成功!",
    });
    genderFlag.value = true;
    return false;
}

$.ajax({
    url: "http://124.222.105.205:5000/api/user/updateUserGender",
    data: {
        userGender: userGender,
        userId: store.state.user.id,
    },
    type: "post",
    headers: {
        Authorization: "Bearer " + token,
    },
    success(resp) {
        if (resp.code == "200") {
        ElMessage({
            type: "success",
            message: resp.msg,
        });
        location.reload();
        } else {
        ElMessage({
            type: "error",
            message: resp.msg,
        });
        }
    },
    error() {
        ElMessage({
        type: "error",
        message: "服务器异常!请稍后再试!",
        });
    },
});


}


const editPhone = () => {

let phone = $("#phone").val();

if (phone == store.state.user.phone) {
    ElMessage({
        type: "success",
        message: "修改成功!",
    });
    phoneFlag.value = true;
    return false;
}

$.ajax({
    url: "http://124.222.105.205:5000/api/user/updateUserPhone",
    data: {
        phone: phone,
        userId: store.state.user.id,
    },
    type: "post",
    headers: {
        Authorization: "Bearer " + token,
    },
    success(resp) {
        if (resp.code == "200") {
        ElMessage({
            type: "success",
            message: resp.msg,
        });
        location.reload();
        } else {
        ElMessage({
            type: "error",
            message: resp.msg,
        });
        }
    },
    error() {
        ElMessage({
        type: "error",
        message: "服务器异常!请稍后再试!",
        });
    },
});


}

const editIntroduce = () => {
    let introduce = $("#introduce").val();

    if (introduce == store.state.user.introduce) {
        ElMessage({
            type: "success",
            message: "修改成功!",
        });
        introduceFlag.value = true;
        return false;
    }

    $.ajax({
        url: "http://124.222.105.205:5000/api/user/updateUserIntroduce",
        data: {
            introduce: introduce,
            userId: store.state.user.id,
        },
        type: "post",
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
            ElMessage({
                type: "success",
                message: resp.msg,
            });
            location.reload();
            } else {
            ElMessage({
                type: "error",
                message: resp.msg,
            });
            }
        },
        error() {
            ElMessage({
            type: "error",
            message: "服务器异常!请稍后再试!",
            });
        },
    });
}

const editEmail = () => {
    let email = $("#email").val();

    if (email == store.state.user.email) {
        ElMessage({
            type: "success",
            message: "修改成功!",
        });
        emailFlag.value = true;
        return false;
    }

    if (! emailRegex.test(email)) {
        ElMessage({
            type: "error",
            message: "邮箱格式错误",
        });
        return false;
    }


    $.ajax({
        url: "http://124.222.105.205:5000/get/user/hasUesrByEmail",
        type: "post",
        data:{
            email: email,
        },
        success(resp) {
            if (resp.code == "200"){
                ElMessage({
                    type: "error",
                    message: "该邮箱已存在",
                });
            } else {
                // 发送验证码
                $.ajax({
                    url: "http://124.222.105.205:5000/visitor/api/mail/sendMail",
                    type: "post",
                    data: {
                    email: email,
                    },
                    contentType: "application/json;charset=utf-8",
                    success(resp) {
                    if (resp.code === "200") {
                        ElMessage({
                            type: "success",
                            message: resp.msg,
                        });
                        codeFlag.value = false;
                    } else {
                        ElMessage({
                            type: "error",
                            message: resp.msg,
                        });
                    }
                    }
                });
            }
        },
        error() {
            ElMessage({
                type: "error",
                message: "服务器端异常!请稍后再试!",
            });
        }
    });

}


const editEmailOk = () => {

    let code = $("#code").val();
    let email = $("#email").val();

    if (code == null || code == "") {
        ElMessage({
            type: "error",
            message: "验证码不能为空",
        });
        return false;
    }

    // 判断验证码
    $.ajax({
        url: "http://124.222.105.205:5000/get/user/judgeCode",
        type: "post",
        data:{
            email: email,
            code: code,
        },
        success(resp) {
            if (resp.code === "200") {
                // 更改邮箱
                $.ajax({
                    url: "http://124.222.105.205:5000/api/user/updateUserEmail",
                    data: {
                        email: email,
                        userId: store.state.user.id,
                    },
                    type: "post",
                    headers: {
                        Authorization: "Bearer " + token,
                    },
                    success(resp) {
                        if (resp.code == "200") {
                        ElMessage({
                            type: "success",
                            message: resp.msg,
                        });
                        location.reload();
                        } else {
                        ElMessage({
                            type: "error",
                            message: resp.msg,
                        });
                        }
                    },
                    error() {
                        ElMessage({
                        type: "error",
                        message: "服务器异常!请稍后再试!",
                        });
                    }
                })
            } else {
                ElMessage({
                    type: "error",
                    message: "验证码错误",
                });
                return false;
            }
        }
    });
}

const editPassword = () => {
    let oldPassword = $("#oldPassword").val();
    let newPassword = $("#newPassword").val();
    let rightPassword = $("#rightPassword").val();


    if (oldPassword == null || oldPassword == "") {
        ElMessage({
            type: "error",
            message: "旧密码不能为空!",
        });
        return false;
    }
    
    if (newPassword == null || newPassword == "" || newPassword.length < 6) {
        ElMessage({
            type: "error",
            message: "新密码长度至少为6",
        });
        return false;
    }


    if (newPassword != rightPassword) {
        ElMessage({
            type: "error",
            message: "两次密码不一致!",
        });
        return false;
    }

    $.ajax({
        url: "http://124.222.105.205:5000/api/user/updateUserPassword",
        data: {
            oldPassword: oldPassword,
            newPassword: rightPassword,
            userId: store.state.user.id,
        },
        type: "post",
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
            ElMessage({
                type: "success",
                message: resp.msg,
            });
            router.push({name: "login"});
            } else {
            ElMessage({
                type: "error",
                message: resp.msg,
            });
            }
        },
        error() {
            ElMessage({
            type: "error",
            message: "服务器异常!请稍后再试!",
            });
        }
    })
}

</script>

<style scoped>
.userAvatar {
    width: 300px;
    margin: 10px;
    border-radius: 20%;
}

.infoBorder {
    margin: 10px;
}

.font_1 {
    color:rgb(134, 134, 134);
    font-size: 20px;
    text-align: center;
    font-weight: bold;
}

.imgBtn {
   width: 100px;
   margin: 20px;
   font-size: 15px;
   
}

.elBorder {
    margin: 10px;
}
</style>